__turbopack_context__.v({
  "footer": "left-rail-module-scss-module__5T8v_a__footer",
  "icon": "left-rail-module-scss-module__5T8v_a__icon",
  "item": "left-rail-module-scss-module__5T8v_a__item",
  "itemActive": "left-rail-module-scss-module__5T8v_a__itemActive",
  "label": "left-rail-module-scss-module__5T8v_a__label",
  "localeSwitcher": "left-rail-module-scss-module__5T8v_a__localeSwitcher",
  "logo": "left-rail-module-scss-module__5T8v_a__logo",
  "logoExp": "left-rail-module-scss-module__5T8v_a__logoExp",
  "logoLink": "left-rail-module-scss-module__5T8v_a__logoLink",
  "logoLinkExp": "left-rail-module-scss-module__5T8v_a__logoLinkExp",
  "nav": "left-rail-module-scss-module__5T8v_a__nav",
  "root": "left-rail-module-scss-module__5T8v_a__root",
});
